import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { I18nService } from '@app/services/i18n/i18n.service';
import { ToolTips } from '@app/src/util/labels.util';
import { Messages as msg } from '@app/src/util/messages';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { RouteStateService } from '@app/services/route-state.service';

/**

 * ********************************************************
 * Header component
 * Creates and displays the header bar
 * Contains  the optimus logo, user info
 * ********************************************************
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  /*************** Variable declarations ***************/
  // isLanguageIconVisible: boolean = false;
  tooltipMsg = ToolTips
  dashboardURL: any;
  noLink = msg.noLink;
  cicdDisabled = false;
  
  // Route state observables from centralized service
  isWorkflowSummaryView$ = this.routeStateService.isWorkflowSummaryView$;
  isPrerequisiteView$ = this.routeStateService.isWorkflowPrerequisiteView$;
  isWorkflowExecutionHistoryView$ = this.routeStateService.isWorkflowExecutionHistoryView$;

  // Getter properties for template access
  get isWorkflowSummaryView(): boolean {
    return this.routeStateService.isWorkflowSummaryView;
  }

  get isPrerequisiteView(): boolean {
    return this.routeStateService.isWorkflowPrerequisiteView;
  }

  get isWorkflowExecutionHistoryView(): boolean {
    return this.routeStateService.isWorkflowExecutionHistoryView;
  }

  /**
   * Constructor
   * @param authService 
   */
  constructor(public readonly authService: AuthService,
    public router: Router,
    public i18nService: I18nService,
    public cmnService: CommonFunctionalitiesService,
    public readonly routeStateService: RouteStateService) {
  }

  /** ngOnInit */
  ngOnInit() {
    // Route state is now handled by RouteStateService
    // No need for manual route detection logic here
  }

  /**
  * @description call on the click of logout
  * @memberof LayoutComponent
  */
  logout() {
    this.authService.startLogout();
  }

  /**
   * On click of logo user will be navigated to dashboard page
   */
  navigateToDash() {
    this.router.navigate(['/dashboard']);
  }

}
